import Admin from "./admin"


const AdminFrom = () => {
    return (
        <div >
            <Admin />
        </div>
    )
}

export default AdminFrom
